import { jsxs as r, jsx as m } from "react/jsx-runtime";
import "react";
import { ThemeProvider as o } from "@mui/material/styles";
import i from "@mui/material/CssBaseline";
import { c as s } from "./theme-utBhuIhS.js";
const c = ({ children: e }) => /* @__PURE__ */ r(o, { theme: s(), children: [
  /* @__PURE__ */ m(i, {}),
  e
] });
export {
  c as T
};
